// <!-- GRACE:MODULE_START name="ui_templates" -->
// <!-- GRACE:DEPENDENCY target="ui_config" -->
// <!-- GRACE:DEPENDENCY target="ui_auth" -->
// Frontend service for calling backend template API
import API_ENDPOINTS from '../config/api';
import { authHeaders } from './authService';

export interface Template {
  id: string;
  name: string;
  description: string;
  template: string;
  is_default: boolean;
  created_at: string;
}

export interface FormatTextResponse {
  original_text: string;
  formatted_text: string;
  template_id: string;
  template_name: string;
  processing_time: number;
}

// <!-- GRACE:CONTRACT function="fetchTemplates" -->
/**
 * Fetch all available templates from backend
 */
export async function fetchTemplates(): Promise<Template[]> {
  try {
    const response = await fetch(API_ENDPOINTS.TEMPLATES.LIST, {
      method: 'GET',
      headers: authHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const templates = await response.json();
    return templates;
  } catch (error) {
    console.error('Error fetching templates:', error);
    throw error;
  }
}

// <!-- GRACE:CONTRACT function="formatTextByTemplate" -->
/**
 * Format text using a specific template via backend GPT service
 */
export async function formatTextByTemplate(
  text: string,
  templateId: string
): Promise<FormatTextResponse> {
  try {
    const response = await fetch(API_ENDPOINTS.TEMPLATES.FORMAT, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({
        text,
        template_id: templateId,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error formatting text by template:', error);
    throw error;
  }
}

// <!-- GRACE:MODULE_END name="ui_templates" -->
